import ErrorBoundary from '@whizz/react-error-boundary';
import { useI18n } from '@whizz/react-i18n';
import type { ReactNode } from 'react';
import React from 'react';

const ErrorBoundaryWrapper = ({ children, ...rest }: Record<string, unknown>): JSX.Element => {
  const { locale } = useI18n();

  return (
    <ErrorBoundary {...rest} locale={locale?.getId()}>
      {children as ReactNode}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;
